import React from 'react'
import utils from '../../Utils'
import SnackBar from 'components/SnackBar'
import Loading from 'components/Loading'
import Header from 'components/Header'
import Matrix from 'scripts/Matrix'
import axios from 'axios';
import ConsultHistoryItem from './ConsultHistoryItem'


import 'style/consult/ConsultHistory.css';

class ConsultHistory extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      consultRequestId: props.match.params.consultRequestId || props.consultRequestId,
      consults: []
    }
  }

  consultHistory = async () => {
    if (!this.state.consultRequestId) return
    this.setState({ loading: true })
    let result = await axios.post(utils.urls.consultHistory, { consultRequestId: this.state.consultRequestId }, {
      headers: {
        'x-access-token': Matrix.getToken()
      }
    }).catch((e) => {
      console.log(e.response)
      let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
      this.SnackBar.openSnackbar(message)
    });
    this.setState({ loading: false })

    if (!result) return
    // console.log(result, '###############')

    let { success, listOfConsults } = result.data;
    if (!success) return this.SnackBar.openSnackbar('خطایی پیش آمده است')
    this.setState({ consults: listOfConsults })
  }
  componentDidMount() {
    this.consultHistory()
  }
  render() {
    return (
      <React.Fragment>
        <Header title="تاریخچه مشاوره ها" showBackButton={true} desc='مشاوره های گذشته آقای ...' />
        <div className="consult-history-container">
          <SnackBar ref={el => { this.SnackBar = el }}></SnackBar>
          {this.state.consults.map(consult =>
            <ConsultHistoryItem key={consult.id} consultRequest={consult} ></ConsultHistoryItem>
          )}
          {this.state.loading && <div className="Loading"><Loading /></div>}
        </div>
      </React.Fragment>
    )
  }
}
export default ConsultHistory